// 運行指示書（配送指示書）印刷ページの URL を、印刷ごとの一時オプションから生成する。
// いずれも永続化しないトグル（DirectionSettingDialog）由来:
//   - displayOnlyUnloading: 納品のみ表示する → action=降
//   - truncate:            省略表示          → truncate=1
export function buildDirectionPrintPath(
  navigateToPath: string,
  opts: { displayOnlyUnloading: boolean; truncate: boolean },
): string {
  const params = [
    opts.displayOnlyUnloading ? 'action=降' : null,
    opts.truncate ? 'truncate=1' : null,
  ].filter((it): it is string => !!it);

  if (params.length === 0) return navigateToPath;

  // navigateToPath に既存のクエリ（?）があれば & で、なければ ? で連結する。
  const separator = navigateToPath.includes('?') ? '&' : '?';
  return `${navigateToPath}${separator}${params.join('&')}`;
}
